import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { render } from 'react-dom';
import Navigation from '../_components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import _ from 'lodash';
import "@progress/kendo-theme-bootstrap/dist/all.css";
import { Grid, GridColumn, GridDetailRow, GridToolbar } from '@progress/kendo-react-grid';
import { userService } from '../_services';
import styles from './UsersPage.module.css';
import { withRouter } from 'Components/withRouter';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';

class DeleteCell extends React.Component {
  render() {

    if (this.props.authenticatedUser && this.props.dataItem && this.props.authenticatedUser.id == this.props.dataItem.id)
      return <td colSpan={this.colSpan}></td>;

    return (
        <td colSpan={this.colSpan}>
            <button className="btn btn-dl-green pull-right" onClick={event => {this.props.DeleteUser(event,this.props.dataItem)}}>DELETE</button>
        </td>
    );
  }
}
class EditCell extends React.Component {
  render() {
      return (
          <td colSpan={this.colSpan}>
              <button className="btn btn-dl-green pull-right" onClick={event => {this.props.EditUser(event,this.props.dataItem)}}>EDIT</button>
          </td>
      );
  }
}

class PermissionsCell extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    var content = '';

    var editUser = this.props.dataItem;

    if (editUser.privileges) {
      var permissions = _.join(editUser.privileges.map(p => p.description), ', ');

      content += permissions;
    }

    return (
      <td colSpan={this.colSpan}>
        {content}
      </td>
    );
  }
}

class UsersPage extends React.Component {
  
  DeleteUser = (event,record) => {
    event.preventDefault();

    var confirmation = window.confirm("This will delete the selected user, continue?");

    if (confirmation !== true)
        return;

    var user_id = record.id;
    userService.deleteUser(user_id)
    .then((response) => {
        if (response.status === 200) {
          this.fetchData();
        }
    })
    .catch(error => {
        this.setState({
            error:error
        });
    });
  }

  AddUser = () => {
    this.props.router.navigate(('/user?id=-1'));
  }

  EditUser = (event,record) => {
    event.preventDefault();
    var user_id = record.id;
    this.props.router.navigate('/user?id=' + user_id);
    // window.alert(user_id);
  }

  fetchData = () => {

    var self = this;

    userService.getUsers()
    .then(response => {
      if (response.status === 200) {
        self.setState({
            users: {
              data: response.data,
              total: response.data.length
            },
            loaded: true
        });
      }
    })
    .catch(error => {
      console.log(error);
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      users: { data: [], total: 0 }
    };
  }

  componentDidMount() {

    this.fetchData();
    
  }

  EditCell = (props) => <EditCell {...props} EditUser={this.EditUser} />
  DeleteCell = (props) => <DeleteCell {...props} DeleteUser={this.DeleteUser} authenticatedUser={this.props.authenticatedUser}/>
  PermissionsCell = (props) => <PermissionsCell {...props} />

  render() {

    if (!this.state.loaded) {
      return (<LoadingPageContent />);
    }

    var privileges = null;

    if (this.props.authenticatedUser) {
      privileges = this.props.authenticatedUser.privileges;
    }


    var canMaintainUsers = privileges && _.some(privileges, ['description', 'Maintain Web Users']);

    if (!canMaintainUsers)
      return <Navigate to="/Welcome" />

    var state = this.state;

    var canModifyUsers = privileges && _.some(privileges, ['description', 'Can Modify Users']);

    return (
      <div id="admin_users">
        <Navigation active="admin" authenticatedUser={this.props.authenticatedUser} />
        <div className="container-fluid padding-lr55 bg-form">
            <div className="row">
                <div className="col-xs-12">
                    <div className="row h3">
                        <div className="col-xs-12">Web Users</div>
                    </div>
                </div>
            </div>
        </div>

        <div className="padding-tb10" />

        <div className="container-fluid padding-lr55">
          <div className="row">
            <div style={{clear:"both"}}/>
            <div className="col-xs-12" >
              <div>
                <Grid
                  styleName="styles.grid"
                  filterable={false}
                  sortable={false}
                  pageable={false}
                  data={state.users.data}
                  total={state.users.total}
                  onFetchData={this.onFetchData}
                  resizable
                >
                  {
                    canModifyUsers &&
                    <GridToolbar>
                      <button className="btn btn-dl-green" onClick={this.AddUser}>NEW USER</button>
                    </GridToolbar>
                  }
                  <GridColumn field="email" title="Email (login)" width="300px"/>
                  <GridColumn field="name" title="Full Name" width="300px" />
                  <GridColumn field="phone" title="Phone" width="180px" />
                  <GridColumn field="is_active" title="Active" width="80px"/>
                  <GridColumn field="permissions" title="Permissions" cell={this.PermissionsCell} width="600px" />
                  {
                    canModifyUsers &&
                    <GridColumn field="id" title=" " cell={this.EditCell} width="100px"/>
                  }
                  {
                    canModifyUsers &&
                    <GridColumn field="id" title=" " cell={this.DeleteCell} width="120px" />
                  }                  
                </Grid>
                <div className="padding-tb10" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const authenticatedUsersPage = withAuthenticatedUser(withRouter(UsersPage));

export { authenticatedUsersPage as UsersPage };